import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import { Card } from 'reactstrap';
import { find } from 'lodash';
import Spinner from '~/components/spinner/spinner';
import FilterInput from '~/components/filterInput/filterInput';
import ReportTable from '~/components/reportTable/reportTable';
import request from '~/utils/request';
import { openResponse } from '~/utils/links';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import config from '~/config/config.json';

export const getCustomsReportsQuery = gql`
  query customsReports($breweryId: Int!, $type: CustomsReportType) {
    customsReports(breweryId: $breweryId, type: $type) {
      id
      createdAt
      autogenerated
      lots {
        id
        reference
      }
      createdByUser {
        id
        firstName
        lastName
      }
    }
  }
`;

export class ReportList extends Component {
  state = {
    filteredReports: [],
    filterText: ''
  };

  downloadReport = async reportId => {
    const reportResponse = await request(`${config.api.url}/report/${reportId}`, {}, true);
    await openResponse(reportResponse, `${this.props.reportFileName}.pdf`);
  };

  onFilterChange = (event, reports) => {
    const { value } = event.target;
    if (!value.length) {
      return this.setState({
        filteredReports: [],
        filterText: ''
      });
    }
    const filterValue = value.toLowerCase();

    const filteredReports = reports.filter(report => {
      // We're only checking for lot references
      return !!find(report.lots, lot => lot.reference.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1);
    });

    return this.setState({
      filterText: value,
      filteredReports
    });
  };

  render() {
    const { brewery, reportType } = this.props;
    const { filterText, filteredReports } = this.state;
    return (
      <Query
        query={getCustomsReportsQuery}
        variables={{ breweryId: brewery.id, type: reportType }}
        fetchPolicy={'cache-and-network'}
      >
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const reports = filterText.length ? filteredReports : data.customsReports;
          return (
            <Fragment>
              <Card className="content">
                <div className="flex pa3 w-100">
                  <FilterInput onChange={e => this.onFilterChange(e, data.customsReports)} className="flex-grow-1" />
                </div>
                <ReportTable onDownload={this.downloadReport} reports={reports} />
              </Card>
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(ReportList);



// WEBPACK FOOTER //
// ./src/containers/reportList/reportList.jsx